import { render, staticRenderFns } from "./DiaryCopy.vue?vue&type=template&id=676265ad"
import script from "./DiaryCopy.vue?vue&type=script&lang=js"
export * from "./DiaryCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports